<template>
<div>
    <router-view></router-view>
    <notifications group="response"/>
</div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      // msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

